module.exports = __webpack_public_path__ + "static/media/curtain.ba105e60.svg";